import { persist } from 'zustand/middleware';

import { createStore } from '@store/createStore';

const useActionItemsStorePersist = createStore(
  persist(
    (set) => ({
      type: { value: 'all', label: 'All' },
      urgency: { value: 'all', label: 'All' },
      status: { value: 'all', label: 'All' },
      extraPanel: 'statistic',

      actions: {
        setAIType: (type) => set({ type }),
        setAIResetFilterState: () =>
          set({
            type: { value: 'all', label: 'All' },
            urgency: { value: 'all', label: 'All' },
            status: { value: 'all', label: 'All' },
          }),
        setAIUrgencyType: (urgency) => set({ urgency }),
        setAIExtraPanel: (extraPanel) => set({ extraPanel }),
        setAIStatusType: (status) => set({ status }),
        setAIColumnName: (columnName) => set({ columnName }),
      },
    }),
    {
      version: 1,
      name: 'actionItem-filters',
      partialize: (state) => Object.fromEntries(Object.entries(state).filter(([key]) => key !== 'actions')),
    },
  ),
  'ActionItemsStorePersist',
);

export const useActionItemsStorePersistAction = () => useActionItemsStorePersist((state) => state.actions);

export const selectAIType = () => useActionItemsStorePersist((state) => state.type);
export const selectAIUrgency = () => useActionItemsStorePersist((state) => state.urgency);
export const selectAIStatus = () => useActionItemsStorePersist((state) => state.status);
export const selectActionItemsExtraPanel = () => useActionItemsStorePersist((state) => state.extraPanel);
